/* @ngInject */
const newTrain = (
  utils
) => {
  const self = {}

  self.classic = () => {
    return {
      id: null,
      number: null,
      date: utils.date.getTodayString(),
      dateBegin: null,
      dateEnd: null,
      tractionnaire: null,
      arrival: null,
    }
  }

  self.search = () => {
    return {
      id: null,
      idNull: 'any',
      idOperator: '!',
      number: null,
      numberNull: 'any',
      numberOperator: '=',
      date: null,
      dateBegin: null,
      dateEnd: null,
      tractionnaire: null,
      tractionnaireNull: 'any',
      tractionnaireOperator: '=',
      arrival: null,
    }
  }

  return self
}

export default newTrain



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/train/services/new.service.js